import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const inputVariants = cva(
  "w-full px-4 py-3 rounded-xl text-sm transition-all focus:outline-none focus:ring-2",
  {
    variants: {
      variant: {
        light: "bg-gray-50 border border-gray-200 text-gray-900 placeholder-gray-400 focus:border-purple-400 focus:ring-purple-100",
        dark: "bg-white/[0.04] border border-white/[0.1] text-white placeholder-gray-600 focus:border-purple-500/50 focus:ring-purple-500/10",
      },
    },
    defaultVariants: {
      variant: "light",
    },
  }
)

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, ...props }, ref) => (
    <input ref={ref} className={cn(inputVariants({ variant, className }))} {...props} />
  )
)
Input.displayName = "Input"

export { Input, inputVariants }
